import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, Typography } from 'seagull';
import { MenuItem } from 'seagull/components/MenuItem';
import { netTermsOptions } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { defaultWidth } from '../agreement-controllers/constants';
const NetTermsDropdown = (param)=>{
    let { netTerms, onChange, isReadOnly, testId, dropdownWidth = defaultWidth, dataAgentTarget } = param;
    const { t: texts } = useLocaleKeys('components.netTermsDropdown');
    const getDisplayValue = (numDays)=>numDays === 0 ? texts.uponReceipt() : texts.days({
            count: numDays
        });
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                as: "p",
                children: texts.daysUntilPaymentDue()
            }),
            /*#__PURE__*/ _jsx(Select, {
                collapseHelperText: false,
                mobile: {
                    renderAsCard: true
                },
                style: {
                    marginBlockStart: 8
                },
                disabled: isReadOnly,
                value: netTerms,
                isSelected: (itemValue, currentValue)=>+itemValue === +currentValue,
                displayValue: getDisplayValue(netTerms),
                SelectProps: {
                    renderValue: ()=>getDisplayValue(netTerms)
                },
                onChange: (e)=>{
                    onChange(+e.target.value);
                },
                testId: testId,
                bi: {
                    name: 'net_terms'
                },
                width: dropdownWidth,
                menuMaxHeight: 200,
                "data-agent-target": dataAgentTarget,
                children: netTermsOptions.map((numOfDays, idx)=>{
                    const value = numOfDays.toString();
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        value: value,
                        testId: "".concat(testId, "-option-").concat(idx),
                        children: getDisplayValue(numOfDays)
                    }, value);
                })
            })
        ]
    });
};
export default NetTermsDropdown;
